import type {UseFormReturn} from 'react-hook-form'

import type {BulkOrderFormValues} from '../../../../BulkOrdersFormValues'
export const useResetSlotSiloConfig = () => {
  const resetSlotSiloConfig = (parentForm: UseFormReturn<BulkOrderFormValues>, index: number) => {
    parentForm.setValue(`orders.${index}.payload.slot.externalReference`, '')
    parentForm.setValue(`orders.${index}.payload.slot.loadingStation`, '')
    parentForm.setValue(`orders.${index}.payload.slot.siloNumber`, '')
  }

  return {resetSlotSiloConfig}
}
